<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="`【${pageName}】${$t('SystemMaintenance.FieldPermissionSettings')}`"
    width="1200px"
    :close-on-click-modal="false"
    class="field-permission-set-dialog"
  >
    <div class="section" style="height: 100%;padding: 0 5px;display: flex;flex-direction: row;">
      <cargo-ag-grid
        :grid-options="left.gridOptions"
        :row-data="left.rowData"
        :show-side-bar="false"
        class="left-grid"
        style="flex: 0 0 auto;width: 200px;margin: 5px 0;"
      />
      <div style="flex: 0 0 auto;width: 2px;margin: 0 5px;background: #DCDFE6;" />
      <div class="main-content" style="flex-grow: 1;margin: 5px 0;display: flex;flex-direction: column;">
        <div class="operations">
          <div class="triggers">
            <div style="padding-left: 5px;margin-bottom: 5px;">
              <el-input v-model="keyword" :placeholder="$t('SystemMaintenance.FieldNameQuery')" style="width: 300px;" />
              <el-button type="primary" @click="onSearch">{{ $t('queryJob.Search') }}</el-button>
              <span style="margin: 0 5px 0 10px;">{{ $t('CargoMsg.Cargo_GeneralSettings') }}</span>
              <el-checkbox v-model="permissionManage.useHqSet" style="margin-right: 10px" @change="onUseHqSet" />
              <el-button key="save" type="success" @click="onSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
              <el-button key="cancel" type="success" @click="onCancel">{{ $t('Message.Cancel') }}</el-button>
            </div>
          </div>
        </div>
        <cargo-ag-grid
          :grid-options="right.gridOptions"
          :column-defs="rightColumnDefs"
          :row-data="rightRowData"
          :show-side-bar="false"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getLobPositionList, getElementPermissionManage, saveElementPermissionManage } from '@/api/sysManage/uiCustom'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import lodash from 'lodash'

export default {
  name: 'FieldPermissionSetDialog',
  props: {
    visible: { type: Boolean, required: true },
    pageType: { type: Number, required: true },
    pageName: { type: String, required: true },
    lob: { type: String, required: true },
    branchId: { type: Number, required: true },
    blocks: { type: Array, required: true }
  },
  data() {
    return {
      innerVisible: false,
      left: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressContextMenu: false,
          columnDefs: [{
            headerName: this.$t('CargoMsg.Cargo_Post'),
            field: 'label',
            width: 187,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false,
            headerClass: 'text-center',
            cellClass: 'text-center'
          }],
          context: {
            componentParent: this
          },
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          onCellFocused: event => {
            const nodes = event.api.rowModel.rowsToDisplay
            const selectedNode = nodes[event.rowIndex] || null
            this.leftSelectedRow = selectedNode ? selectedNode.data : null
            this.elementLabelLike = ''
          }
        },
        rowData: []
      },
      leftSelectedRow: null,
      right: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressContextMenu: false,
          context: {
            componentParent: this
          }
        }
      },
      keyword: '',
      elementLabelLike: '',
      permissionManage: { useHqSet: false },
      hqPermissions: [],
      permissions: [],
      originPermissions: [],
      deletedPermissionKeys: [],
      repeatElementLabelSet: new Set() // 重复的元素lable
    }
  },
  computed: {
    leftGridApi() {
      return this.left.gridOptions.api
    },
    rightColumnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_FieldName'),
          field: 'elementLabel',
          width: 300
        },
        {
          headerName: this.$t('Message.Display'),
          field: 'viewable',
          width: 150,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            attrs: {
              isEditCBFunc: params => {
                return (this.branchId === 1 || !this.permissionManage.useHqSet) && !params.data.disabled
              }
            },
            tag: 'el-checkbox2',
            valueChanged: p => {
              this.onCellChange(p)
            }
          }
        },
        {
          headerName: this.$t('SystemMaintenance.CanWrite'),
          field: 'writable',
          width: 150,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            attrs: {
              isEditCBFunc: params => {
                return (this.branchId === 1 || !this.permissionManage.useHqSet) && !params.data.disabled && params.data.viewable
              }
            },
            tag: 'el-checkbox2',
            valueChanged: p => {
              this.onCellChange(p)
            }
          }
        }
      ]
    },
    rightRowData() {
      const result = []
      if (!this.leftSelectedRow) {
        return result
      }
      for (const item of this.permissions) {
        if (item.positionField !== this.leftSelectedRow.positionField) {
          continue
        }
        if (this.elementLabelLike) {
          if (!item.elementLabel.includes(this.elementLabelLike)) {
            continue
          }
        }
        result.push(item)
      }
      return result
    },
    rightGridApi() {
      return this.right.gridOptions.api
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          const labelSet = new Set()
          for (const block of this.blocks) {
            for (const element of block.uiCustomElementList) {
              const elementLabel = element.customLabel || element.sysLabel
              if (labelSet.has(elementLabel)) {
                this.repeatElementLabelSet.add(elementLabel)
              } else {
                labelSet.add(elementLabel)
              }
            }
          }
          await Promise.all([
            getLobPositionList({ lob: this.lob }).then(res => {
              this.left.rowData = [
                { lob: this.lob, positionField: 'all', label: this.$t('SystemMaintenance.AllPositions2') },
                ...res.data
              ]
            }),
            getElementPermissionManage({ pageType: this.pageType, branchId: this.branchId }).then(res => {
              this.permissionManage = res.data
            })
          ])
          this.hqPermissions = this.permissionManage.hqUiCustomElementPermissions || []
          this.permissions = this.permissionManage.uiCustomElementPermissions || []
          this.hqPermissions = this.syncBlockAndPermissions(this.hqPermissions)
          this.permissions = this.syncBlockAndPermissions(this.permissions)
          this.onUseHqSet()
          this.originPermissions = lodash.cloneDeep(this.permissions)
          setTimeout(() => {
            this.leftGridApi.setFocusedCell(1, 'label')
          }, 10)
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.left.rowData = []
        this.leftSelectedRow = null
        this.keyword = ''
        this.elementLabelLike = ''
        this.permissionManage = { useHqSet: false }
        this.hqPermissions = []
        this.permissions = []
        this.originPermissions = []
        this.deletedPermissionKeys = []
        this.repeatElementLabelSet = new Set()
      }
    }
  },
  methods: {
    syncBlockAndPermissions(permissions) {
      if (!permissions) {
        return []
      }
      const permissionGroup = new Map()
      for (const item of permissions) {
        let permissionList = permissionGroup.get(item.elementName)
        if (!permissionList) {
          permissionList = []
          permissionGroup.set(item.elementName, permissionList)
        }
        permissionList.push(item)
      }
      const newPermisssions = []
      for (const block of this.blocks) {
        const blockLabel = block.customLabel || block.sysLabel
        for (const element of block.uiCustomElementList) {
          const permissionList = permissionGroup.get(element.pagePartElement.elementName)
          if (permissionList) {
            for (const permission of permissionList) {
              if (!element.isDisplay) {
                permission.viewable = false
                permission.writable = false
              }
              const elementLabel = element.customLabel || element.sysLabel
              if (this.repeatElementLabelSet.has(elementLabel)) {
                permission.elementLabel = blockLabel + '-' + elementLabel
              } else {
                permission.elementLabel = elementLabel
              }
              permission.disabled = !element.isDisplay
              newPermisssions.push(permission)
            }
            permissionGroup.delete(element.pagePartElement.elementName)
          }
        }
      }
      for (const permissionList of permissionGroup.values()) {
        for (const permission of permissionList) {
          if (permission.uuid) {
            this.deletedPermissionKeys.push(permission.uuid)
          }
        }
      }
      return newPermisssions
    },
    onUseHqSet() {
      this.elementLabelLike = ''
      if (this.branchId === 1) {
        return
      }
      if (this.permissionManage.useHqSet) {
        for (const item of this.permissions) {
          if (item.uuid) {
            this.deletedPermissionKeys.push(item.uuid)
          }
        }
        this.permissions = Array.from(this.hqPermissions, p => {
          return {
            elementPermissionManageUuid: '',
            positionField: p.positionField,
            elementName: p.elementName,
            elementLabel: p.elementLabel,
            disabled: p.disabled,
            viewable: p.viewable,
            writable: p.writable
          }
        })
      } else {
        this.permissions = [...this.permissions]
      }
    },
    onSearch() {
      this.elementLabelLike = this.keyword
    },
    onCellChange(p) {
      const { data, field, value } = p
      let allCallback = (item, value) => {
        item[field] = value
      }
      if (field === 'viewable') {
        if (!value) {
          data.writable = false
          allCallback = (item, value) => {
            item.viewable = false
            item.writable = false
          }
        }
        const nodes = this.rightGridApi.rowModel.rowsToDisplay
        const selectedNode = nodes[this.rightGridApi.getFocusedCell().rowIndex]
        // 刷新可写列
        this.rightGridApi.refreshCells({
          rowNodes: [selectedNode],
          columns: ['writable'],
          force: true
        })
      } else {
        if (data.writable) {
          allCallback = (item, value) => {
            item.viewable = true
            item.writable = true
          }
        }
      }
      if (this.leftSelectedRow?.positionField === 'all' && (field === 'viewable' || field === 'writable')) {
        for (const item of this.permissions) {
          if (item.positionField === 'all') {
            continue
          }
          if (item.elementName !== data.elementName) {
            continue
          }
          allCallback(item, value)
        }
      }
    },
    onSave() {
      let permissions = this.permissions
      let compressPermissions = []
      if (this.permissionManage.useHqSet && this.branchId !== 1) {
        for (const item of permissions) {
          if (item.uuid) {
            this.deletedPermissionKeys.push(item.uuid)
          }
        }
        permissions = []
        compressPermissions = []
      } else {
        // 【页签的所有字段】乘以【10个岗位】，需保存的记录数太多，容易出现接口调用超时
        // 因此，只保存与初始值不一样的记录
        const originPermissionMap = new Map()
        for (const originPermission of this.originPermissions) {
          originPermissionMap.set(originPermission.positionField + '-' + originPermission.elementName, originPermission)
        }
        compressPermissions = []
        for (const permission of permissions) {
          const originPermission = originPermissionMap.get(permission.positionField + '-' + permission.elementName)
          if (!originPermission) {
            compressPermissions.push(permission)
          } else {
            if (permission.viewable !== originPermission.viewable || permission.writable !== originPermission.writable) {
              compressPermissions.push(permission)
            }
          }
        }
      }
      const loading = getLoading4Cxt(this)
      saveElementPermissionManage({
        ...this.permissionManage,
        hqUiCustomElementPermissions: null,
        uiCustomElementPermissions: compressPermissions,
        deletedPermissionKeys: [...new Set(this.deletedPermissionKeys)]
      }).then(() => {
        this.$emit('updateCallback')
        this.$message.success(this.$t('Message.SaveSuccessfully'))
        this.innerVisible = false
      }).finally(() => {
        loading.close()
      })
    },
    onCancel() {
      this.innerVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.field-permission-set-dialog::v-deep {
  .el-dialog {
    margin-top: 5vh !important;
    .el-dialog__body {
      height: 80vh;
    }
  }
  .left-grid {
    .ag-header {
      .ag-cell-label-container {
        padding-left: 0;
      }
      .ag-header-cell-text {
        width: 100%;
      }
    }
    .ag-body-viewport {
      .ag-cell-value {
        text-indent: 20px;
      }
    }
  }
}
</style>
